module.exports = __webpack_public_path__ + "static/media/paper30.f979ab14.jpg";